import { createEvoClient, quizzesGetUserSubmissions, quizzesStoreUserSubmission } from "@jti/evo-client";

export type QuizAnswer = {
  type: string;
  answer_id: string;
  question_id: string;
  reference_name: string;
  local_translation: string;
};

export type QuizResult = {
  type: string;
  email: string;
  answers: QuizAnswer[];
  created_at: number;
  quiz_uuid: string;
};

export type QuizQuestion = {
  type: string;
  question_id: string;
  reference_name: string;
  local_translation: string;
};

export type QuizPayload = {
  answers: QuizAnswer[];
  results: QuizResult[];
  questions: QuizQuestion[];
};

export type QuizSubmission = {
  user_uuid: string;
  quiz_payload: QuizPayload;
};

export type QuizResponse = {
  data: QuizSubmission[];
  correlation_id?: string;
};

export type CreateQuizResponse = {
  message: string;
  data?: {
    [key: string]: unknown;
  };
};

export type QuizApiContract = {
  getUserSubmissions(userUuid: string): Promise<QuizResponse>;
  createSubmission(userUuid: string, submission: QuizPayload): Promise<CreateQuizResponse>;
};

export class QuizApiEvo implements QuizApiContract {
  private readonly client;
  constructor(baseUrl: string, tenantToken: string, userToken: string, recaptchaId: string) {
    this.client = createEvoClient({
      baseUrl,
      tenantToken,
      recaptchaId,
      ciamToken: userToken,
      throwOnError: true,
    });
  }

  async getUserSubmissions(userUuid: string): Promise<QuizResponse> {
    const { data } = await quizzesGetUserSubmissions({
      client: this.client,
      path: {
        userUuid,
      },
    });

    return data as QuizResponse;
  }

  async createSubmission(userUuid: string, submission: QuizPayload): Promise<CreateQuizResponse> {
    const { data } = await quizzesStoreUserSubmission({
      client: this.client,
      path: {
        userUuid,
      },
      body: {
        answers: submission.answers,
        results: { ...submission.results },
        questions: submission.questions,
      },
    });

    return data as CreateQuizResponse;
  }
}
